"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EGameFeatureTypes = void 0;
var EGameFeatureTypes;
(function (EGameFeatureTypes) {
    EGameFeatureTypes["Unknown"] = "UNKNOWN";
    EGameFeatureTypes["Bonus"] = "BONUS";
    EGameFeatureTypes["BuyBonus"] = "BUY_BONUS";
    EGameFeatureTypes["Other"] = "OTHER";
    EGameFeatureTypes["NotABonus"] = "NOT_A_BONUS";
})(EGameFeatureTypes = exports.EGameFeatureTypes || (exports.EGameFeatureTypes = {}));
